import { render } from "./ClinicAppointmentRecordOverlay.vue?vue&type=template&id=22bd1950&scoped=true&lang=pug"
import script from "./ClinicAppointmentRecordOverlay.vue?vue&type=script&lang=js"
export * from "./ClinicAppointmentRecordOverlay.vue?vue&type=script&lang=js"

import "./ClinicAppointmentRecordOverlay.vue?vue&type=style&index=0&id=22bd1950&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bd1950"]])

export default __exports__